import { useMemo } from 'react';
import { getStyleObjectFromString } from 'utils/getStyleObjectFromString';
import { useDisplayFrameworkContext } from './hooks/useDisplayFrameworkContext';

const EMPTY_OBJECT = {};

export default function useComponentConfiguration(comcode: string) {
  const { getComponentConfiguration } = useDisplayFrameworkContext();

  const config = getComponentConfiguration(comcode);

  return useMemo(
    () => ({
      isHidden: config?.flaghide ?? false,
      style: config
        ? typeof config.comstyle === 'string'
          ? getStyleObjectFromString(config?.comstyle)
          : EMPTY_OBJECT
        : EMPTY_OBJECT,
      styleAsString:config?.comstyle,
      label: config ? config.comlabel : `##${comcode}`,
      placeholder: config?.complaceholder,
      required: config?.flagrequired ?? false,
      message: config?.commessage,
      hint: config?.comhint,
      isDisabled: config?.flagdisabled,
    }),
    [comcode, config]
  );
}
